import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=136ed646&scoped=true&"
import script from "./Fleet.vue?vue&type=script&lang=js&"
export * from "./Fleet.vue?vue&type=script&lang=js&"
import style0 from "./Fleet.vue?vue&type=style&index=0&id=136ed646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ed646",
  null
  
)

export default component.exports